import moment from "moment";
import {
  STANDARD_APP_DATE_FORMAT,
  STANDARD_APP_DATE_TIME_FORMAT,
  STANDARD_APP_HOUR_MINUTE_FORMAT,
} from "../constants/constants";

export const convertDate = (targetDate: string) => {
  let date = new Date(targetDate);

  date = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
};

export const formatDate = (date: string) => {
  return moment(date).format(STANDARD_APP_DATE_FORMAT);
};

export const formatDateWithTime = (date: string) => {
  return moment(date).format(STANDARD_APP_DATE_TIME_FORMAT);
};
export const formatHoursMinutes = (time: string | null | undefined) => {
  if (!time) {
    return "--";
  }

  const m = moment(time);
  return m.isValid() ? m.format(STANDARD_APP_HOUR_MINUTE_FORMAT) : "--";
};

export const formatDuration = (decimalHours: string | number): string => {
  if (!decimalHours && decimalHours !== 0) return "";

  const num =
    typeof decimalHours === "string" ? parseFloat(decimalHours) : decimalHours;

  if (isNaN(num) || num < 0) return "";

  const totalMinutes = Math.round(num * 60);

  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;

  let result = "";
  if (days > 0) result += `${days}d`;
  if (hours > 0) result += (result ? " " : "") + `${hours}h`;
  if (minutes > 0) result += (result ? " " : "") + `${minutes}m`;

  return result || "0m";
};

export const fDate = (date: string, format = "YYYY-MM-DD") => {
  return moment(date, format).format(STANDARD_APP_DATE_FORMAT);
};

export const fDateTime = (date: string, format = "YYYY-MM-DD") => {
  return moment(date, format).format(STANDARD_APP_DATE_TIME_FORMAT);
};
